module.exports = __webpack_public_path__ + "img/lv2.04415cb7.png";